export default __webpack_public_path__ + "static/media/google_play_hover.0d9887a3.svg";